import Icon from '../components/Icon.vue'

Icon.register({
  'store-alt': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M320 384v-160h64v256c0 17.7-14.3 32-32 32h-256c-17.7 0-32-14.3-32-32v-256h64v160h192zM634.6 142.2c14.1 21.3-1.1 49.8-26.6 49.8h-575.9c-25.6 0-40.8-28.5-26.6-49.8l85.3-128c5.9-8.9 15.9-14.2 26.6-14.2h405.2c10.7 0 20.7 5.3 26.7 14.2zM512 496v-272h64v272c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/store-alt.js
// module id = 1957
// module chunks = 0